import React from "react"

function IconFileImageTimes({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="file-image-times"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-file-image-times"
      {...props}
    >
      <path
        d="M12.045 21.851a7.067 7.067 0 0 1-.667-1.31H5.021a.473.473 0 0 1-.464-.387l-.008-.085V3.959c0-.23.167-.423.388-.463l.084-.008 9.626.001v4.324c0 .325.237.595.548.646l.106.008 4.213.001v2.603c.455.1.893.242 1.31.423V7.813a.655.655 0 0 0-.12-.38l-.066-.078-4.87-4.98a.655.655 0 0 0-.363-.188l-.104-.008H5.02c-.93 0-1.696.715-1.774 1.627l-.007.153v16.11c0 .932.717 1.697 1.628 1.775l.153.006 7.024.001zM18.613 7.16h-2.657V4.441l2.657 2.718zM8.503 11.41a1.778 1.778 0 1 0 0-3.555 1.778 1.778 0 0 0 0 3.555zm2.546 8a7.093 7.093 0 0 1 5.883-8.421l-1.318-1.357-5.481 5.643-2.074-2.087-2.223 2.237v3.984l5.213.001zM18 23.564a5.564 5.564 0 1 0 0-11.128 5.564 5.564 0 0 0 0 11.128zm0-1.31a4.255 4.255 0 1 1 0-8.509 4.255 4.255 0 0 1 0 8.51zm-1.782-2.213a.6.6 0 0 0 .765.07l.083-.07 1.063-1.064 1.064 1.064.083.07a.6.6 0 0 0 .835-.835l-.07-.083-1.064-1.064 1.064-1.063.07-.083a.6.6 0 0 0-.835-.835l-.083.07-1.064 1.062-1.063-1.063-.083-.07a.6.6 0 0 0-.835.836l.07.083 1.063 1.063-1.063 1.064-.07.083a.6.6 0 0 0 .07.765z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconFileImageTimes
